import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
// import { isEmpty, max } from 'lodash'
import { connect } from 'react-redux'
import {
  // Field,
  Form,
  formValueSelector,
  reduxForm,
  getFormValues
} from 'redux-form'
// import useMediaQuery from '@material-ui/core/useMediaQuery'
import FirstStepThemeForm from './FirstStepThemeForm'
import SecondStepThemeForm from './SecondStepThemeForm'
// import moment from 'moment'

// import DropzoneInput from '../shared/DropzoneInput'
// import DatePickerInput, { TimePickerInput } from '../shared/DatePickerInput'
import configSVG from '../../assets/icons/config-gear-icon.svg'
import fillContentSVG from '../../assets/icons/stepper-theme-icon.svg'
import viewSVG from '../../assets/icons/pattern-view-icon.svg'
// // import destinationsSVG from '../../assets/icons/sended-icon.svg'
// import docSVG from '../../assets/icons/doc.svg'
// import videoSVG from '../../assets/icons/video.svg'
// import audioSVG from '../../assets/icons/audio.svg'
// import linkSVG from '../../assets/icons/material-link.svg'
// import crossAddSVG from '../../assets/icons/cross-add-icon.svg'
// import HighlightOffIcon from '@material-ui/icons/HighlightOff'
// import imgSVG from '../../assets/icons/img.svg'
import { createThemeRSPA } from '../../store/themes/actions'
// import FormProgress from '../shared/FormProgress'

// import { required } from '../../utils/formUtils'
// import { roles } from '../../utils/constants'

const useStyles = makeStyles(theme => ({
  root: {
    fontFamily: 'Montserrat, Source Sans Pro',
    width: '98%',
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    margin: 'auto',
    height: '95%',
    padding: '32px',
    marginBottom: '100px'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 16,
    '& .title': {
      display: 'flex',
      alignItems: 'center',
      columnGap: 12
    },
    '& path': {
      stroke: '#4D5E80'
    },
    '& h1': {
      fontWeight: 700,
      color: '#4D5E80',
      fontSize: 32,
      margin: 0
    },
    '& span': {
      color: '#555555',
      fontSize: 16,
      maxWidth: '25%'
    }
  },
  steps: {
    marginTop: 40,
    display: 'flex',
    flexDirection: 'column',
    rowGap: 8,
    '& p': {
      margin: 0,
      fontWeight: 700,
      fontSize: 16
    },
    '& span': {
      fontWeight: 500,
      fontSize: 14
    }
  },
  inputField: {
    display: 'flex',
    flexDirection: 'column',
    width: 'fit-content'
  },
  title: {
    width: '100%'
  },
  description: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 8,
    '& label': {
      fontSize: 16,
      fontWeight: 600
    }
  },
  descriptionRootStyle: {
    padding: 0,
    marginBottom: 0,
    border: '1.5px solid #ADB8CC',
    '& .mce-edit-area': {
      minHeight: '120px'
    },
    '& .mce-container-body': {
      display: 'flex',
      flexDirection: 'column-reverse'
    },
    '& .mce-btn-group .mce-btn': {
      margin: 0,
      backgroundColor: 'transparent'
    },
    '& .mce-toolbar-grp': {
      width: 'fit-content',
      backgroundColor: '#F6F7F8',
      boxShadow: '3px 11px 14px 6px #6B67671A',
      margin: '0px 30px 30px 40px',
      height: 'fit-content',
      borderRadius: 8
    },
    '& .mce-btn': {
      '& button': {
        height: 50
      }
    },
    '& .mce-panel': {
      backgroundColor: 'unset'
    }
  },
  label: {
    marginBottom: 8,
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '24px'
  },
  selectCover: {
    marginTop: 60,
    display: 'flex',
    flexDirection: 'column',
    '& label': {
      marginBottom: 20,
      fontWeight: 600,
      fontSize: 16,
      color: 'rgba(85, 85, 85, 1)'
    }
  },
  bottomBtns: {
    marginTop: 50,
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 10,
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'center',
      display: 'flex',
      flexDirection: 'column-reverse',
      alignItems: 'center',
      '& button': {
        width: '200px !important'
      }
    },
    '& button': {
      width: 150
    }
  },
  cancelBtn: {
    width: 146,
    border: '2px solid #EF7C8F',
    height: 44,
    padding: '14px 48px',
    gap: 10,
    color: '#EF7C8F',
    borderRadius: 8,
    '&:hover': {
      border: '2px solid #EF7C8F'
    },
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'capitalize',
    lineHeight: '19.5px'
  },
  sendBtn: {
    backgroundColor: '#386093',
    width: 148,
    height: 44,
    padding: '14px 48px',
    gap: 10,
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#386093'
    },
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'capitalize',
    lineHeight: '19.5px'
  },
  moduleInfos: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    '& span': {
      color: '#ADB8CC',
      fontSize: 14,
      fontWeight: 500
    },
    '& p': {
      margin: 0,
      color: '#555555',
      fontSize: 18,
      fontWeight: 700
    }
  },
  formTitle: {
    marginTop: 24,
    marginBottom: 15,
    '& p': {
      color: '#ADB8CC',
      fontSize: 14,
      fontWeight: 500
    }
  },
  themeInfosRow: {
    margin: '24px 0px',
    display: 'flex',
    alignItems: 'center',
    gap: 26,
    '& .segment': {
      width: '50%'
    },
    '& .skills': {
      width: '50%'
    }
  }
}))

const NewCreateThemeForm = ({
  isEdit,
  handleSubmit,
  userOccupations,
  change,
  touch,
  initialValues,
  step,
  ...props
}) => {
  // const isAdmin =
  //   userOccupations?.includes(roles.VERSAR_ADMIN) ||
  //   userOccupations?.includes(roles.SCHOOL_ADMIN)
  const classes = useStyles()

  const [currentStep, setCurrentStep] = React.useState(step || 0)

  // validação de cada etapa
  // const handleStepper = stepIndex => {
  //   if (stepIndex === 1) {
  //     if(isAdmin) {
  //       return true
  //     }
  //     return true
  //   } else if (stepIndex === 2) {
  //     return true
  //   } else {
  //     return true
  //   }
  // }
  const handleNext = () => {
    setCurrentStep(prevCurrentStep => {
      const newState = prevCurrentStep + 1
      change('currentStep', newState)
      return newState
    })
  }

  const handleBack = () => {
    setCurrentStep(prevCurrentStep => {
      const newState = prevCurrentStep - 1
      change('currentStep', newState)
      return newState
    })
  }

  const getStepContent = stepIndex => {
    switch (stepIndex) {
      case 0:
        return (
          <FirstStepThemeForm
            {...props}
            handleNext={handleNext}
            touch={touch}
            change={change}
            handleChange={handleChange}
            setCurrentStep={setCurrentStep}
            currentStep={currentStep}
            steps={[
              { key: 'Configurações', icon: configSVG },
              { key: 'Foco e conteúdo', icon: fillContentSVG },
              { key: 'Preview', icon: viewSVG }
            ]}
          />
        )
      case 1:
        return (
          <SecondStepThemeForm
            {...props}
            handleNext={handleNext}
            handleBack={handleBack}
            handleChange={handleChange}
            currentStep={currentStep}
            steps={[
              { key: 'Configurações', icon: configSVG },
              { key: 'Foco e conteúdo', icon: fillContentSVG },
              { key: 'Preview', icon: viewSVG }
            ]}
          />
        )
      case 2:
        return <div>3</div>
      default:
        return ''
    }
  }

  const handleChange = (event, input) => {
    touch(input.name)
    let newValue
    if (Array.isArray(event)) {
      newValue = event?.map(v => v)
    } else {
      newValue = event ? event.value : ''
    }
    change(input.name, newValue)
  }

  // const handleToggle = () => {
  //   // valid && setOpen(!open)
  // }

  return (
    <div className={classes.root}>
      <Form onSubmit={handleSubmit}>{getStepContent(currentStep)}</Form>
    </div>
  )
}

const mapStateToProps = (state, props) => {
  const selector = formValueSelector('newCreateThemeForm')
  return {
    segmentValue: selector(state, 'segment_id'),
    currentSchool: state.school.currentSchool.school,
    currentModule: state.modules.currentItem.item,
    currentTheme: state.themes.currentItem.item,
    fieldValues: getFormValues('newCreateThemeForm')(state),
    modules: state.modules
  }
}

const mapDispatchToProps = dispatch => ({
  createThemeRSPA: data => dispatch(createThemeRSPA.request(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'newCreateThemeForm',
    enableReinitialize: true,
    onSubmit: async (values, dispatch, props) => {
      if (values.currentStep === 0) {
        const { currentStep, ...newValues } = values
        await props
          .createThemeRSPA({
            ...newValues,
            school: props.currentSchool,
            module: props.currentModule
          })
          .then(res => {
            props.history.push(`/newthemes/${res.id}/contents`)
          })
          .catch(error => error)
      }
    }
  })(NewCreateThemeForm)
)
